/**
 * Pagination Constants
 *
 * Contains reusable constants for pagination components.
 * Separated from components to comply with React Fast Refresh rules.
 */

export const DEFAULT_PER_PAGE = 10;
export const PER_PAGE_OPTIONS = [10, 25, 50, 100, 200, 500] as const;
